/** Carte listant les insights automatiques (tendance, adhérence, plateau…). */
import type { Insight } from '@/domain';

const ICON: Record<Insight['tone'], string> = {
  good: '✅',
  warn: '⚠️',
  info: 'ℹ️',
};

const COLOR: Record<Insight['tone'], string> = {
  good: 'var(--good)',
  warn: 'var(--warning)',
  info: 'var(--accent)',
};

export function InsightsCard({ insights }: { insights: Insight[] }) {
  if (insights.length === 0) return null;
  return (
    <div className="card">
      <h3>Analyse rapide</h3>
      <ul style={{ listStyle: 'none', padding: 0, margin: '0.5rem 0 0' }}>
        {insights.map((ins) => (
          <li
            key={ins.text}
            style={{
              display: 'flex',
              gap: '0.55rem',
              alignItems: 'baseline',
              padding: '0.35rem 0',
              borderLeft: `3px solid ${COLOR[ins.tone]}`,
              paddingLeft: '0.6rem',
              marginBottom: '0.35rem',
            }}
          >
            <span>{ICON[ins.tone]}</span>
            <span style={{ fontSize: '0.9rem' }}>{ins.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
